export const GET_FRIENDS_REQUEST = "FRIEND.GET_FRIENDS_REQUEST";
export const GET_FRIENDS_SUCCESS = "FRIEND.GET_FRIENDS_SUCCESS";
export const GET_FRIENDS_FAILURE = "FRIEND.GET_FRIENDS_FAILURE";

export const GET_LIST_USER_REQUEST = "FRIEND.GET_LIST_USER_REQUEST";
export const GET_LIST_USER_SUCCESS = "FRIEND.GET_LIST_USER_SUCCESS";
export const GET_LIST_USER_FAILURE = "FRIEND.GET_LIST_USER_FAILURE";

export const GET_SENT_REQUESTS_REQUEST = "FRIEND.GET_SENT_REQUESTS_REQUEST";
export const GET_SENT_REQUESTS_SUCCESS = "FRIEND.GET_SENT_REQUESTS_SUCCESS";
export const GET_SENT_REQUESTS_FAILURE = "FRIEND.GET_SENT_REQUESTS_FAILURE";

export const GET_RECEIVED_REQUESTS_REQUEST =
  "FRIEND.GET_RECEIVED_REQUESTS_REQUEST";
export const GET_RECEIVED_REQUESTS_SUCCESS =
  "FRIEND.GET_RECEIVED_REQUESTS_SUCCESS";
export const GET_RECEIVED_REQUESTS_FAILURE =
  "FRIEND.GET_RECEIVED_REQUESTS_FAILURE";

export const SEND_FRIEND_REQUEST_STARTED = "FRIEND.SEND_FRIEND_REQUEST_STARTED";
export const SEND_FRIEND_REQUEST_SUCCESS = "FRIEND.SEND_FRIEND_REQUEST_SUCCESS";
export const SEND_FRIEND_REQUEST_FAIL = "FRIEND.SEND_FRIEND_REQUEST_FAIL";

export const CANCEL_FRIEND_REQUEST_STARTED =
  "FRIEND.CANCEL_FRIEND_REQUEST_STARTED";
export const CANCEL_FRIEND_REQUEST_SUCCESS =
  "FRIEND.CANCEL_FRIEND_REQUEST_SUCCESS";
export const CANCEL_FRIEND_REQUEST_FAIL = "FRIEND.CANCEL_FRIEND_REQUEST_FAIL";

export const REMOVE_FRIEND_STARTED = "FRIEND.REMOVE_FRIEND_STARTED";
export const REMOVE_FRIEND_SUCCESS = "FRIEND.REMOVE_FRIEND_SUCCESS";
export const REMOVE_FRIEND_FAIL = "FRIEND.REMOVE_FRIEND_FAIL";

export const ACCEPT_FRIEND_STARTED = "FRIEND.ACCEPT_FRIEND_STARTED";
export const ACCEPT_FRIEND_SUCCESS = "FRIEND.ACCEPT_FRIEND_SUCCESS";
export const ACCEPT_FRIEND_FAIL = "FRIEND.ACCEPT_FRIEND_FAIL";

export const DECLINE_FRIEND_STARTED = "FRIEND.DECLINE_FRIEND_STARTED";
export const DECLINE_FRIEND_SUCCESS = "FRIEND.DECLINE_FRIEND_SUCCESS";
export const DECLINE_FRIEND_FAIL = "FRIEND.DECLINE_FRIEND_FAIL";
